import {Bling as GPT} from "react-gpt";
import {adUnits, sizeMappings} from '../../services/adUnits';
import {useAuth} from "../../services/use-auth";
import classNames from 'classnames';
import {useState} from "react";

export default function AdvertiseBlock({unitId, blockLocation, className, entityId = ''}) {
    const auth = useAuth();
    const [visible, setVisible] = useState(true);

    if (!auth.user || !auth.user.showAdvertisement || !visible) {
        return null;
    }

    const gptCode = process.env.REACT_APP_GPT_NETWORK_CODE;
    const adUnit = adUnits[unitId];
    const slotId = '/' + gptCode + '/' + adUnit.name;
    const blockId = unitId + '--' + blockLocation + '--0';
    const sizeMapping = sizeMappings[adUnit.name];
    const style = {
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'width .5s, height .5s',
        display: 'flex',
    };
    const onSlotRenderEndedHandler = (event) => {
        if (event.isEmpty === true) {
            setVisible(false);
        }
    };

    return (
        <div className={classNames('acc-common', 'acc-' + blockLocation, className)} style={style}>
            <GPT
                id={blockId}
                adUnitPath={slotId}
                slotSize={adUnit.size}
                collapseEmptyDiv={[true, true]}
                onSlotRenderEnded={onSlotRenderEndedHandler}
                targeting={{
                    Category1: adUnit.category1,
                    Category2: adUnit.category2 ? adUnit.category2 + entityId : '',
                    MedicalSpeciality: [],
                }}
                sizeMapping={sizeMapping}
            />
        </div>
    )
}
